import { render, staticRenderFns } from "./AbastecimentoModal.vue?vue&type=template&id=791a7f39&scoped=true"
import script from "./AbastecimentoModal.vue?vue&type=script&lang=js"
export * from "./AbastecimentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a7f39",
  null
  
)

export default component.exports